module.exports = __webpack_public_path__ + "style/img/SP_icon_Info.1a5e42b2.png";